import {styled} from '@mui/material';

export const NewCardsContainer = styled('div')(() => ({}));

export const TwitterCardsContainer = styled('div')(() => ({
  marginTop: 30,
}));
